"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  animation: ", " 4s linear infinite;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n100% {\n  transform:rotate(360deg);\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLoader = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _stylitas = require("@creditas/stylitas");

var _core = require("@emotion/core");

var spin = (0, _stylitas.keyframes)(_templateObject());

var animation = function animation() {
  return (0, _stylitas.css)(_templateObject2(), spin);
};

var IconLoader = function IconLoader(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props, {
    css: animation
  }), (0, _core.jsx)("defs", null, (0, _core.jsx)("path", {
    d: "M7.333 10.667c.369 0 .667.298.667.666V14a.667.667 0 01-1.333 0v-2.667c0-.368.298-.666.666-.666zm3.298-.978l1.887 1.886a.667.667 0 01-.943.943L9.69 10.631a.667.667 0 11.942-.942zm-5.653 0c.26.26.26.682 0 .942l-1.887 1.887a.667.667 0 01-.942-.943L4.035 9.69c.26-.26.683-.26.943 0zM3.333 6.667a.667.667 0 110 1.333H.667a.667.667 0 110-1.333h2.666zm10.667 0A.667.667 0 0114 8h-2.667a.667.667 0 010-1.333H14zM3.091 2.149l1.887 1.886a.667.667 0 11-.943.943L2.15 3.091a.667.667 0 11.942-.942zm9.427 0c.26.26.26.682 0 .942l-1.887 1.887a.667.667 0 11-.942-.943l1.886-1.886c.26-.26.683-.26.943 0zM7.333 0C7.702 0 8 .298 8 .667v2.666a.667.667 0 11-1.333 0V.667c0-.369.298-.667.666-.667z",
    id: "loader_svg__a"
  })), (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M-8-8h32v32H-8z"
  }), (0, _core.jsx)("g", {
    transform: "translate(.667 .667)"
  }, (0, _core.jsx)("mask", {
    id: "loader_svg__b",
    fill: "#fff"
  }, (0, _core.jsx)("use", {
    xlinkHref: "#loader_svg__a"
  })), (0, _core.jsx)("use", {
    fill: "#889",
    fillRule: "nonzero",
    xlinkHref: "#loader_svg__a"
  }), (0, _core.jsx)("g", {
    mask: "url(#loader_svg__b)",
    fill: "#ABB"
  }, (0, _core.jsx)("path", {
    d: "M-8.667-8.667h32v32h-32z"
  })))));
};

exports.IconLoader = IconLoader;